import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UrlConfigService } from 'app/service/url-config.service';

@Injectable({
  providedIn: 'root',
})
export class SsoLoginService {
  url: string;

  constructor(private httpClient: HttpClient, private urlConfigService: UrlConfigService) {
    this.url = this.urlConfigService.apiServerUrl;
  }

  generateSsoToken(urlArray): Observable<any> {
    return this.httpClient.get(this.url + 'sso/generateToken?' + urlArray);
  }

  // ssoLogin(param): Observable<any> {
  // return this.httpClient.get(AppSetting.baseUrl + '/sso/login?' + param);
  //  }

  ssoLogin(jwt): Observable<any> {
    return this.httpClient.post(this.url + 'ssoToken', jwt, { responseType: 'text' });
  }
}
